module.exports = __webpack_public_path__ + "static/media/IMG_1859.6e2b1b95.JPG";